import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./components/context/Themecontext"; // ← import
import Home from "./components/pages/Home";
import User from "./components/pages/User";
import Login from "./components/pages/Login";
import Departamento from "./components/pages/Departamento";
import Conteudo from "./components/pages/Conteudo";
import Formacao from "./components/pages/FormacaoRead";
import Quiz from "./components/pages/Quiz";

const App = () => {
  return (
    <ThemeProvider>  
      <Router>
        <Routes>
          <Route path="/"      element={<Login />} />
          <Route path="/:code" element={<Login />} />
          <Route path="/home"  element={<Home />} />
          <Route path="/quiz/:codigo_acesso"  element={<Quiz />} />
          
        </Routes>
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        toastStyle={{ borderRadius: 12 }}
      />
    </ThemeProvider>
  );
};

export default App;